import React from "react";
import AuthLayout from "../AuthLayout/AuthLayout";
import { Button } from "antd";
import * as Yup from "yup";
import { ErrorMessage, Field, Formik, Form as FormikForm } from "formik";
import InputField from "../../components/Input/Inputfeild";
import { useNavigate } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "./ForgetPassword.css";

const ForgetPassword = () => {
  const initialValues = {
    email: "",
  };

  const history = useHistory();

  const validationSchema = Yup.object({
    email: Yup.string().email().required("Please input your email!"),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    console.log("Form submitted with values:", values);
  };
  return (
    <AuthLayout>
      <div className="signin-container">
        <div className="signin-header">
          <h1>Forget Password</h1>
          <p>Enter the email address associated with your account and we will send you a code to reset your password</p>
        </div>

        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ isSubmitting, errors, touched }) => (
            <FormikForm className="login-form">
              <div className="input-wrapper">
                <p>Email Address</p>
                <Field name="username">
                  {({ field }) => (
                    <InputField
                      {...field}
                      placeholder="Email Address"
                      className={`custom-input ${errors.username && touched.username ? "input-error" : ""}`}
                    />
                  )}
                </Field>
                <ErrorMessage name="username" component="div" className="error-message" />
              </div>

              <div className="back-to-signin-container">
                <label className="back-to-signin forget-password " onClick={() => history.push("/login")}>
                  Back to Sign In
                </label>
              </div>

              <Button htmlType="submit" type="primary" className="signin-btn" disabled={isSubmitting}>
                {isSubmitting ? "Sending..." : "Send Verification Code"}
              </Button>
            </FormikForm>
          )}
        </Formik>
      </div>
    </AuthLayout>
  );
};

export default ForgetPassword;
